import { Fragment } from "react";
import { Divider, Stack } from "@mui/material";
import { IWikifolioKeyFigureGroup } from "src/api/server/wf-detail.types";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { KeyFigure } from "src/components-mui/common/key-figure/key-figure";

interface IKeyFigureGroupProps {
    keyFigureGroup: IWikifolioKeyFigureGroup;
    showHeadline?: boolean;
}

interface IKeyFigureColumnProps {
    rankings: IWikifolioKeyFigureGroup["rankings"];
}

const KeyFigureColumn = ({ rankings }: IKeyFigureColumnProps) => (
    <Stack sx={{ width: "100%", alignItems: "center", lineHeight: 1.25 }}>
        {rankings.map((ranking, index) => (
            <Fragment key={index}>
                <KeyFigure {...ranking} fontSize="sm" />
                <Divider sx={{ width: "100%", borderColor: "gray.100" }} />
            </Fragment>
        ))}
    </Stack>
);

export const KeyFigureGroup = ({ keyFigureGroup, showHeadline }: IKeyFigureGroupProps) => {
    const { label, rankings } = keyFigureGroup;

    const pivot = Math.ceil(rankings.length / 2);
    const firstColumnRankings = rankings.slice(0, pivot);
    const secondColumnRankings = rankings.slice(pivot);

    return (
        <>
            {showHeadline && (
                <WfHeading component="h3" fontSize="md" sx={{ mb: 1 }}>
                    {label}
                </WfHeading>
            )}
            <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 0, sm: 5 }} sx={{ width: "100%", fontSize: "sm" }}>
                <KeyFigureColumn rankings={firstColumnRankings} />
                <KeyFigureColumn rankings={secondColumnRankings} />
            </Stack>
        </>
    );
};
